export function NotFoundPage() {
  return <p>페이지를 찾을 수 없어요</p>;
}
